import { render } from "./Contrato.vue?vue&type=template&id=6325f5c0&scoped=true"
import script from "./Contrato.vue?vue&type=script&lang=js"
export * from "./Contrato.vue?vue&type=script&lang=js"

import "./Contrato.vue?vue&type=style&index=0&id=6325f5c0&lang=scss"
import "./Contrato.vue?vue&type=style&index=1&id=6325f5c0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6325f5c0"]])

export default __exports__